module.exports = __webpack_public_path__ + "static/img/12051C_1_2_R_20201107_fit.157a581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12051C_1_2_R_20201107_fit.png
// module id = +Dno
// module chunks = 0